<template>
  <ValidationProvider tag="div" :rules="rules" :label="label" v-slot="{ errors }">
    <div>
      <!-- {{agencyDet}} -->
      <label>{{label}}</label>

      <multiselect
        v-model="selValueModel"
        :track-by="ctrlCode"
        :label="ctrlName"
        :placeholder="$t('cSortDropDown.select')"
        :options="options"
        :multiple="false"
        :allow-empty="false"
        :loading="isInValidOptions()"
        v-on:input="onSortFlights"
        :showLabels="false"
      >
        <template slot="singleLabel" slot-scope="{ option }">{{ option[ctrlName] }}</template>
        <template slot="option" slot-scope="props">
          <div>
            <span>{{ props.option[ctrlName] }}</span>
            <strong class="right" v-if="isShowCode">{{ props.option[ctrlCode] }}</strong>
          </div>
        </template>
        <span slot="noResult"><strong>{{ $t("noMatchFound.noMatchFound") }}</strong></span>
      </multiselect>

      <div  v-if="errors && errors[0]" class="invalid-feedback icon">
        <div v-show="!selValueModel">
          <span>{{ errors[0] }}</span>
        </div>
      </div>
    </div>
  </ValidationProvider>
</template>

<script>
import { SORT, ORDER, BOUND_TYPE } from "../../util/constants.js";
import _ from "lodash";

import router ,{navigate,goBack }from "../../router/index";
import { ValidationProvider } from "vee-validate";
import Multiselect from "vue-multiselect";
import apiGetAllAgent from "../../services/apiGetAllAgent.js";
import apiGetAgentDetails from "../../services/apiGetAgentDetails.js";
import { mapGetters, mapActions } from "vuex";
import { PATHNAME, COMPONENT_NAME } from "../../util/constants.js";
import BaseConfiguration from "../../config/base.js";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../util/apiValidate.js";
import { handleJWT, getErrorAlertValue, OrderByList } from "../../util/util";
import SERVICE_URL from "../../config/API_DATA";
import Logger from "../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
export default {
  name: COMPONENT_NAME.C_IB_SORT_DROPDOWN,
  components: {
    ValidationProvider,
    Multiselect
  },
  model: {
    prop: "selValue"
  },
  props: {
    isDisable: {
      type: Boolean,
      default: false
    },

    selValue: {
      type: Array | Object,
      default: null
    },
    isShowCode: {
      type: Boolean,
      default: false
    },
    isMultiple: {
      type: Boolean,
      default: false
    },

    ctrlName: {
      type: String,
      default: ""
    },
    ctrlCode: {
      type: String,
      default: ""
    },

    rules: {
      type: [String, Object],
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    flightResult:{
      type:Object|Array,
      default:null
    },
    selValue: {
      type: Object | Array,
      default: null
    },

  },
  data: () => ({
    options: [],
    selValueModel: null,
    lsSortedFlights: [],
    boundType: null,
    flightRes:null,
  }),

  watch: {
    selValue(val) {
      if (val !== this.selValueModel) {
        this.selValueModel = val;
      }
    },
    // flightResult:{
    //     immediate: false, 
    //     deep: true,
    // handler: function (newVal, oldVal) {
      
    //   if(oldVal!=newVal){
    //    this.onSortFlights(this.selValueModel);
    // }
        
    //   }
    //   },
  },

  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log(" created");
       this.selValueModel=this.selValue;
    // this.flightRes=this.flightResult;
      this.options = [
        {
          name: this.$t('flightResults.sortOptions.lowest'),
          code: "LP"
        },
        {
          name: this.$t('flightResults.sortOptions.highest'),
          code: "HP"
        },
        {
          name: this.$t('flightResults.sortOptions.earliest'),
          code: "ED"
        },
        {
          name: this.$t('flightResults.sortOptions.earliestArr'),
          code: "EA"
        },
        {
          name: this.$t('flightResults.sortOptions.shortest'),
          code: "SD"
        }
      ];
      if(!this.selValueModel)
      this.selValueModel = this.options[0];
      this.sortDefSelection(this.selValueModel);
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.C_SORT_DROPDOWN,
        "error while Component created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
  
  computed: {},

  methods: {
    
    //method to default sort
    sortDefSelection(pselValueModel) {
      try {
        if (BaseConfiguration.isDebug) console.log("sortDefSelection");
        this.onSortFlights(pselValueModel);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_IB_SORT_DROPDOWN,
          "error while sorting",
          err.toString(),
          "sortDefSelection",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    //to sort flights based on property value
    onSortFlights(selectedOption) {
      try {
        if (BaseConfiguration.isDebug) console.log("onSortFlights");
        let lsAvailFlights = null;

  
this.$emit("input", selectedOption);
       
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_IB_SORT_DROPDOWN,
          "error while sorting",
          err.toString(),
          "onSortFlights",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },



    ///to check a invalid option
    isInValidOptions() {
      try {
        if (BaseConfiguration.isDebug) console.log(" isInValidOptions");

        let retValue = false;
        if (this.options && this.options.length > 0)
          //check options length
          retValue = false;
        else retValue = true;
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_IB_SORT_DROPDOWN,
          "error while checking invalid options",
          err.toString(),
          "isInValidOptions",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    }
  }
};
</script>

